$(".video-wrap").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.video-mp4, button.video-mp4');
    const thisVideoSrc = video.data('src');
    const thisVTTSrc = video.data('vtt-src');
    const thisVTTLabel = video.data('vtt-label');
    const thisVTTSrcLang = video.data('vtt-srclang');

    video.on( "click", function() {
        const videoHTML = '<video class="video" autoplay controls>'+
                            '<source src="'+thisVideoSrc+'" type="video/mp4" />'+
                            '<track label="'+thisVTTLabel+'" kind="subtitles" srclang="'+thisVTTSrcLang+'" src="'+thisVTTSrc+'" />'+
                        '</video>'
        video.replaceWith(videoHTML);
    });
});

$(".video-wrap-yt").each(function () {
    const videoWrap = $(this);
    const video = videoWrap.find('a.video-yt, button.video-yt');
    var thisVideoSrc = video.data('src');
    const thisTitle = video.data('title');
    
    if (thisVideoSrc.includes('https://youtu.be')) {
        const newStr = thisVideoSrc.split('https://youtu.be/')[1];
        const newYoutubeUrl = 'https://www.youtube.com/embed/' + newStr + '?rel=0&modestbranding=1&autohide=1&mute=1&loop=1&showinfo=0&controls=1&autoplay=1&playsinline=1';
        thisVideoSrc = newYoutubeUrl;
    }

    video.on( "click", function() {
        const videoHTML = '<iframe class="video" src="'+thisVideoSrc+'" title="'+thisTitle+'" allowfullscreen></iframe>'
        video.replaceWith(videoHTML);
    });
});